import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardActions, Typography, Grid, Divider, CardMedia, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  image: {
    width: '100%'
  },
  statsItem: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const Experience = props => {
  var { className, headline, ...rest } = props;
  const classes = useStyles()
  return (
    <Card
      {...rest}
    >
      <CardMedia
        component="img"
        alt={"asdf"}
        height="140"
        image={headline.imageUrl}
      />
      <Divider />
      <CardActions>
        <Grid
          container
          justify="space-between"
        >
          <Grid
            className={classes.statsItem}
            item
          >
            <Typography
              display="inline"
              variant="body2"
              style={{ fontSize: 16 }}
            >
              <Link
                component="a"
                href={headline.href}
              >
                {headline.title}
              </Link>
            </Typography>
          </Grid>
          <Grid
            className={classes.statsItem}
            item
          >
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

Experience.propTypes = {
  headline: PropTypes.object.isRequired
};

export default Experience;